import { mapActions, mapGetters } from "vuex";
import firebase from "@/firebase"
import AlertsService from "@/services/firebase/Alerts/AlertsService";
import AlertApi from "@/services/apiPdf/AlertApi";
import EmailService from "@/services/email/Email";
import DialogSendEmail from "@/components/DialogSendEmail/DialogSendEmail";
import FormReport from "@/components/Forms/Report/Report.vue";
import UnitsService from "@/services/server/UnitsService";
import SectorsService from "@/services/firebase/Sectors/SectorsService";
import UsersServiceFirebase from "@/services/firebase/Users/UsersService.js";
import AlertsConfigService from "@/services/firebase/AlertsConfig/AlertsConfigService.js";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import Utils from '@/scripts/Utils';

export default {
  components: {
    FormReport,
    DialogSendEmail
  },
  data() {
    return {
      alerts_data: [],
      alertsConfigData: [],
      show_expand: true,
      main_headers: [
        {
          text: 'Cliente',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Qntd.', value: 'size', align: 'center' },
        { text: 'Meta Agendada', value: 'goal_scheduled', align: 'center' },
        { text: 'Meta Excedida', value: 'goal_exceeded', align: 'center' },
        { text: 'Alertas de Consumo', value: 'consumption', align: 'center' },
        { text: 'Reservatório', value: 'reservoir', align: 'center' },
        { text: 'Telemetria', value: 'telemetry', align: 'center' },
        { text: 'Ações', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
      secondary_headers: [
        {
          text: 'Unidade',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Qntd.', value: 'size', align: 'center' },
        { text: 'Meta Agendada', value: 'goal_scheduled', align: 'center' },
        { text: 'Meta Excedida', value: 'goal_exceeded', align: 'center' },
        { text: 'Alertas de Consumo', value: 'consumption', align: 'center' },
        { text: 'Reservatório', value: 'reservoir', align: 'center' },
        { text: 'Telemetria', value: 'telemetry', align: 'center' },
        { text: 'Ações', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
      franchisee_id: null,
      client_id: null,
      unit_id: null,
      sector_id: null,
      startDatePicker: [Utils.formatDateDayJs(Utils.subtractDate(new Date(), 1), "YYYY-MM-DD"),
      Utils.formatDateDayJs(new Date(), "YYYY-MM-DD")],
      select_unit: [],
      select_unit_adress: null,
      select_sector_name: null,
      titles_button_download: [{ title: "PDF" }, { title: "Email" }],
      date_format: null,
      reset_client: true,
      last_type_selected: null,
      last_serach_alerts: null,
      data_table: [],
      data_table_expand: [],
      data_table_filter_days: [],
      summary: {
        consumption: 0,
        goal_scheduled: 0,
        goal_exceeded: 0,
        telemetry: 0,
        reservoir: 0,
        size: 0
      },
      desabled: {
        search_button: true,
        report_view: false
      },
      startDateDialog: false,
      maxStartDate: '',
      notification: {
        open: false,
        text: ""
      },
      dialog_send_email: false,
      data_body_email: false,
      report_type: '',
      pdfDialogDownload: false,
      pdfFileLink: null,
      pdfLoading: false,
      usersMap: null,
      // Promise compartilhada para sincronizar catch_id('client') e catch_id('unit')
      _alertsDataPromise: null,
    }
  },
  methods: {
    ...mapActions(["getClientsBy", "getUnitsBy"]),
    async catch_report_tipe(type, func, prop, status) {
      this.report_type = type
      func(prop, status)
    },

    async getUsersMap() {
      const response = await UsersServiceFirebase.getUsers();
      this.usersMap = new Map();
      response.map((user) => {
        this.usersMap.set(user.id, user.name)
      });
    },

    async catch_id(data, onExpand = false) {
      if (!onExpand) this.summary = {
        consumption: 0,
        goal_scheduled: 0,
        goal_exceeded: 0,
        reservoir: 0,
        telemetry: 0,
        size: 0
      }
      const id = data.id

      if (!onExpand) {
        this.data_table = []
        this.last_serach_alerts = data
        this.last_type_selected = data.type
      } else {
        this.data_table_expand = []
      }
      this.show_expand = true
      let alerts = []
      let alertsListTable = []

      try {
        switch (data.type) {
          case "franchisee":
            this.franchisee_id = id;
            if (!onExpand) this.setHeaders("client")
            else this.setHeadersExpand("client")
            this.alerts_data = await this.searchAlertList("id_franchisee", this.franchisee_id)
            alertsListTable = await this.filterAlerts(this.alerts_data, "id_client")
            this.getClientsName(alertsListTable)
            await this.sumValuesTable(alertsListTable)
            if (!onExpand) await this.summarySum(alertsListTable)
            break;
          case "client":
            this.client_id = id;
            if (!onExpand) this.setHeaders("unit")
            else this.setHeadersExpand("unit")
            // Guarda a promise ANTES do await para que case "unit" possa aguardá-la
            // se onExpand disparar enquanto este await ainda está pendente.
            this._alertsDataPromise = this.searchAlertList("id_client", this.client_id)
            this.alerts_data = await this._alertsDataPromise
            alerts = this.alerts_data.filter((alert) => alert.id_client === this.client_id)
            alertsListTable = await this.filterAlerts(alerts, "id_unit")
            await this.getUnitsName(this.client_id, alertsListTable)
            await this.sumValuesTable(alertsListTable)
            if (!onExpand) await this.summarySum(alertsListTable)
            break;
          case "unit":
            if (!onExpand) this.setHeaders("sector")
            else this.setHeadersExpand("sector")
            if (this.last_type_selected === "unit") this.show_expand = false
            this.unit_id = id;
            if (data?.calledByDate) {
              // Recarrega dados quando chamado por mudança de data
              this._alertsDataPromise = this.searchAlertList("id_client", this.client_id)
            }

            // Aguarda a promise iniciada pelo case "client" antes de continuar.
            // Isso garante que this.alerts_data já está populado quando chegamos
            // aqui — mesmo que select-unit tenha emitido o auto-select enquanto
            // catch_id('client') ainda estava pendente no event loop.
            if (this._alertsDataPromise) {
              this.alerts_data = await this._alertsDataPromise
            }
            alerts = this.alerts_data.filter((alert) => alert.id_unit === this.unit_id)
            alertsListTable = await this.alterAlertListSector(alerts)

            if (!onExpand) {
              this.summary = { consumption: 0, goal_exceeded: 0, goal_scheduled: 0, reservoir: 0, telemetry: 0, size: 0 }
              alertsListTable.map((alert) => {
                this.summary.size += 1
                switch (alert.type) {
                  case "goal_exceeded":
                    this.summary.goal_exceeded += 1
                    break;
                  case "goal_scheduled":
                    this.summary.goal_scheduled += 1
                    break;
                  case "consumption":
                    this.summary.consumption += 1
                    break;
                  case "lack_of_signal":
                    this.summary.telemetry += 1
                    break;
                  case "low_battery":
                    this.summary.telemetry += 1
                    break;
                  case "no_variation":
                    this.summary.telemetry += 1
                    break;
                  case "no_communication":
                    this.summary.telemetry += 1
                    break;
                  case "water_probe_base_minimum_level":
                    this.summary.reservoir += 1
                    break;
                  case "water_probe_base_maximum_level":
                    this.summary.reservoir += 1
                    break;
                  case "water_probe_sensor_error":
                    this.summary.reservoir += 1
                    break;
                }
              })
            }
            break;
          default:
            alert("Tipo não identificado entre em contato com o suporte!")
            break;
        }

      } catch {
        alert("Erro não identificado entre em contato com o suporte!")
      }
      if (alertsListTable.length === 0) showErrorSnackBar("Não existe alertas para o item selecionado!")

      // Descarta resultado se uma chamada mais recente já assumiu o controle.
      // last_type_selected é sobrescrito sincronicamente no início de cada
      // catch_id mais novo, então se divergir desta chamada ela é obsoleta.
      if (!onExpand && this.last_type_selected !== data.type) return

      !onExpand ? this.data_table = alertsListTable : this.data_table_expand = alertsListTable
    },
    async alterAlertListSector(alertsGroup) {
      function changeTypeName(type) {
        switch (type) {
          case 'consumption':
            return "Consumo"
          case 'goal_exceeded':
            return "Meta Excedida"
          case 'goal_scheduled':
            return "Meta Agendada"
          case 'lack_of_signal':
            return "Falta de Sinal"
          case 'low_battery':
            return "Bateria Fraca"
          case 'no_variation':
            return "Sem Variação"
          case 'no_communication':
            return "Sem Comunicação"
          case 'water_probe_base_minimum_level':
            return "Nível Mínimo"
          case 'water_probe_base_maximum_level':
            return "Nível Máximo"
          case 'water_probe_sensor_error':
            return "Sonda desconectada"
          default:
            return "Não definido!"
        }
      }
      // Causa #2: se o array chega vazio (consequência da race condition da causa #1),
      // evita chamar a API de setores com um id_unit inválido e retorna imediatamente.
      if (!alertsGroup.length) return []
      const listSectors = await SectorsService.getSectorsByUnitId(alertsGroup[0].id_unit)
      const sorted = [...alertsGroup].sort((a, b) => {
        const sa = a?.date_of_occurrence?.seconds ?? a?.date_of_occurrence?._seconds ?? 0
        const sb = b?.date_of_occurrence?.seconds ?? b?.date_of_occurrence?._seconds ?? 0
        return sb - sa
      })
      return sorted.map((alert) => {
        const alertConfig = this.alertsConfigData.find(({ id_doc }) => id_doc === alert.id_alert_config)
        let sectorByAlert = listSectors.find(({ id_doc }) => id_doc === alert.id_sector)
        if (!sectorByAlert) sectorByAlert = listSectors.find(({ id_modem }) => id_modem === alert.modem_id)
        const date_of_occurrence = Utils.formatDate(new Date(alert.date_of_occurrence.seconds * 1000), '<DD>/<MM>/<YYYY> às <hh>:<mm>:<ss>')
        return {
          ...alert,
          name: alertConfig ? alertConfig.name : changeTypeName(alert.type),
          sectorName: sectorByAlert ? sectorByAlert.name : "",
          typeName: changeTypeName(alert.type),
          type: alert.type,
          point_exceeded: alert.point_exceeded || null,
          limit_consumption: alert.liters_consumed_in_period && alert.liters_exceeded_in_period ? (+alert.liters_consumed_in_period.toFixed(2) - +alert.liters_exceeded_in_period.toFixed(2)) : null,
          liters_consumed_in_period: alert.liters_consumed_in_period ? +alert.liters_consumed_in_period.toFixed(2) : null,
          liters_exceeded_in_period: alert.liters_exceeded_in_period ? Number(alert.liters_exceeded_in_period.toFixed(2)) : null,
          waterHeight: alert.waterHeight || null,
          percentage: alert.percentage || null,
          date_of_occurrence,
        }
      })
    },
    async filterAlerts(AlertsData, entity) {
      let list = []
      if (AlertsData.length > 0) {
        AlertsData.map(alert => {
          let resultSearchId = list.map(i => {
            return i.id === alert[entity]
          }).find(resultMap => resultMap === true)

          if (!resultSearchId) {
            list.push({
              id: alert[entity],
              name: alert[entity],
              size: 1,
              alerts: [alert]
            })
          } else {
            list.map((n) => {
              if (n.id === alert[entity]) {
                n.alerts = [...n.alerts, alert]
                n.size += 1
              }
            })
          }
        })
      }
      return list
    },
    async sumValuesTable(data) {
      data.map((generalAlert, index) => {
        let goal_scheduled = 0
        let goal_exceeded = 0
        let consumption = 0
        let telemetry = 0
        let reservoir = 0
        generalAlert.alerts.map((alert) => {
          switch (alert.type) {
            case "goal_exceeded":
              goal_exceeded += 1
              break;
            case "goal_scheduled":
              goal_scheduled += 1
              break;
            case "consumption":
              consumption += 1
              break;
            case "lack_of_signal":
              telemetry += 1
              break;
            case "low_battery":
              telemetry += 1
              break;
            case "no_variation":
              telemetry += 1
              break;
            case "no_communication":
              telemetry += 1
              break;
            case "water_probe_base_minimum_level":
              reservoir += 1
              break;
            case "water_probe_base_maximum_level":
              reservoir += 1
              break;
            case "water_probe_sensor_error":
              reservoir += 1
              break;
          }
        })
        data[index] = {
          ...data[index],
          goal_scheduled,
          goal_exceeded,
          consumption,
          telemetry,
          reservoir,
          index
        }
      })
    },
    async sendEmail(receiver, message) {
      try {
        if (!this.data_body_email) throw "Body não definido!"
        const name = this.data_body_email.name
        const user_email = receiver
        const relatorio = "Alertas"
        const data = {
          id: this.data_body_email.data.id,
          currentUser: this.data_body_email.data.currentUser,
          rank: this.data_body_email.data.rank,
          report_type: 'PDF',
          type: this.data_body_email.data.type
        }
        const date_time = this.data_body_email.startDatePicker
        const file_name = this.data_body_email.name.split(" ").join("_")
        const endpoint = "/report/alert"

        await EmailService.sendEmail({
          name,
          user_email,
          relatorio,
          data,
          date_time,
          file_name,
          endpoint
        })

        showSuccessSnackBar("Email enviado!")
      } catch (err) {
        console.error(err)
        showErrorSnackBar("Erro ao enviar email!")
      }
      this.data_body_email = null
    },

    getClientsName(data) {
      data.map(({ name }, i) => {
        const clientName = this.usersMap.get(name);
        if (clientName) {
          data[i].id = data[i].name;
          data[i].name = clientName;
        }
      });
    },
    async getUnitsName(clientId, data) {
      const response = await UnitsService.findAllByClient(clientId)
      const unitsByClient = response.data.data
      data.map(({ name }, i) => {
        let unit_data = unitsByClient.filter(({ id }) => name === id)
        if (unit_data.length > 0) {
          data[i].id = data[i].name
          data[i].name = unit_data[0].name
        }
      })
    },
    async getSectoresName(unitId, data) {
      let list = []
      let { sectors } = await firebase.getUnitbyId(unitId);

      if (sectors && sectors.length > 0) {
        list = sectors.map((i) => {
          if (i.name && i.modem) return { name: i.name, id: i.modem.id };
        });

        data.map(({ name }, i) => {
          let sector_data = list.filter(({ id }) => name === id)
          data[i].id = data[i].name
          data[i].name = sector_data[0].name
        })

      } else {
        delete data[0]
        showErrorSnackBar("A Unidade não possui setores vinculados!")
      }
    },
    async summarySum(data) {

      this.summary = {
        consumption: 0,
        goal_exceeded: 0,
        goal_scheduled: 0,
        telemetry: 0,
        reservoir: 0,
        size: 0
      }
      data.map((line) => {
        this.summary.consumption += line.consumption
        this.summary.goal_exceeded += line.goal_exceeded
        this.summary.goal_scheduled += line.goal_scheduled
        this.summary.telemetry += line.telemetry
        this.summary.reservoir += line.reservoir
        this.summary.size += line.size
      })
    },
    formatDateTimestamp() {
      let date = this.startDatePicker.map(date => {
        return (new Date(date).getTime())
      })
      if (date[0] > date[1]) {
        date = [
          date[1],
          date[0]
        ]
      }
      date = [
        new Date(date[0] + 10800000), // 00:00
        new Date(date[1] + 86400000 + 10799999), // 23:59:59
      ]
      this.startDatePicker
      return date
    },
    async onExpand({ item, value }) {
      let type = null
      switch (this.last_type_selected) {
        case "franchisee":
          type = "client"
          break;
        case "client":
          type = "unit"
          break;
      }
      await this.catch_id({ id: item.id, type }, true)
    },
    async getAlertsPerData(selectDate) {
      this.startDatePicker = selectDate
      if (this.last_serach_alerts) {
        const data = { ...this.last_serach_alerts, calledByDate: true }
        await this.catch_id(data, false)
      }
    },
    async searchAlertList(entity, id = null) {
      return await AlertsService.getAlertsPayloadConsumptionAndEntity(entity, id, this.formatDateTimestamp())
    },
    setHeadersExpand(action) {
      switch (action) {
        case 'client':
          this.secondary_headers = [
            {
              text: 'Cliente',
              align: 'start',
              sortable: false,
              value: 'name'
            },
            { text: 'Qntd.', value: 'size', align: 'center' },
            { text: 'Meta Excedida', value: 'goal_exceeded', align: 'center' },
            { text: 'Meta Agendada', value: 'goal_scheduled', align: 'center' },
            { text: 'Alertas de Consumo', value: 'consumption', align: 'center' },
            { text: 'Reservatório', value: 'reservoir', align: 'center' },
            { text: 'Telemetria', value: 'telemetry', align: 'center' },
            { text: 'Ações', value: 'actions', sortable: false },
            { text: '', value: 'data-table-expand' },
          ]
          break;
        case 'unit':
          this.secondary_headers = [
            {
              text: 'Unidade',
              align: 'start',
              sortable: false,
              value: 'name'
            },
            { text: 'Qntd.', value: 'size', align: 'center' },
            { text: 'Meta Excedida', value: 'goal_exceeded', align: 'center' },
            { text: 'Meta Agendada', value: 'goal_scheduled', align: 'center' },
            { text: 'Alertas de Consumo', value: 'consumption', align: 'center' },
            { text: 'Reservatório', value: 'reservoir', align: 'center' },
            { text: 'Telemetria', value: 'telemetry', align: 'center' },
            { text: 'Ações', value: 'actions', sortable: false },
            { text: '', value: 'data-table-expand' },
          ]
          break;
        case 'sector':
          this.secondary_headers = [
            {
              text: 'Alerta',
              align: 'start',
              sortable: false,
              value: 'name'
            },
            { text: 'Setor', value: 'sectorName', align: 'center' },
            { text: 'Tipo', value: 'typeName', align: 'center' },
            { text: 'Consumo no periodo.', value: 'liters_consumed_in_period', align: 'center' },
            { text: 'Consumo Excedido', value: 'liters_exceeded_in_period', align: 'center' },
            { text: 'Limite de Consumo', value: 'limit_consumption', align: 'center' },
            { text: 'Nível m', value: 'waterHeight', align: 'center' },
            { text: 'Bateria %', value: 'percentage', align: 'center' },
            { text: 'Data', value: 'date_of_occurrence', align: 'center' },
          ]
          break;
      }
    },
    setHeaders(action) {
      switch (action) {

        case 'client':

          this.main_headers = [{
            text: 'Cliente',
            align: 'start',
            sortable: false,
            value: 'name'
          },
          { text: 'Qntd.', value: 'size', align: 'center' },
          { text: 'Meta Excedida', value: 'goal_exceeded', align: 'center' },
          { text: 'Meta Agendada', value: 'goal_scheduled', align: 'center' },
          { text: 'Alertas de Consumo', value: 'consumption', align: 'center' },
          { text: 'Reservatório', value: 'reservoir', align: 'center' },
          { text: 'Telemetria', value: 'telemetry', align: 'center' },
          { text: 'Ações', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }]

          break;
        case 'unit':


          this.main_headers = [{
            text: 'Unidade',
            align: 'start',
            sortable: false,
            value: 'name'
          },
          { text: 'Qntd.', value: 'size', align: 'center' },
          { text: 'Meta Excedida', value: 'goal_exceeded', align: 'center' },
          { text: 'Meta Agendada', value: 'goal_scheduled', align: 'center' },
          { text: 'Alertas de Consumo', value: 'consumption', align: 'center' },
          { text: 'Reservatório', value: 'reservoir', align: 'center' },
          { text: 'Telemetria', value: 'telemetry', align: 'center' },
          { text: 'Ações', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }]

          break;
        case 'sector':
          this.main_headers = [{
            text: 'Alerta',
            align: 'start',
            sortable: false,
            value: 'name'
          },
          { text: 'Setor', value: 'sectorName', align: 'center' },
          { text: 'Tipo', value: 'typeName', align: 'center' },
          { text: 'Consumo no periodo.', value: 'liters_consumed_in_period', align: 'center' },
          { text: 'Consumo Excedido', value: 'liters_exceeded_in_period', align: 'center' },
          { text: 'Limite de Consumo', value: 'limit_consumption', align: 'center' },
          { text: 'Nível m', value: 'waterHeight', align: 'center' },
          { text: 'Bateria %', value: 'percentage', align: 'center' },
          { text: 'Data', value: 'date_of_occurrence', align: 'center' },
          ]

          break;
      }
    },

    async generatePdf(item, status = null) {
      let data = {}
      data.id = item.id
      data.currentUser = this.getCurrentUser.uid
      data.rank = this.getCurrentUser.data.rank
      switch (this.last_serach_alerts.type) {
        case "franchisee":
          data.type = status ? "id_unit" : "id_client"
          break;
        case "client":
          data.type = status ? "id_modem" : "id_unit"
          if (item.entity) data.type = "id_client"
          break;
        case "unit":
          data.type = "id_modem"
          if (item.entity) data.type = "id_unit"
          break;
        default:
          console.error("type error!")
      }
      if (this.report_type === "Email") {
        this.dialog_send_email = !this.dialog_send_email
        this.data_body_email = { data, startDatePicker: this.startDatePicker, name: item.name || await this.getClientName(item) }
      } else {

        let response = await AlertApi.generatePdf(data, this.startDatePicker)
        this.pdfFileLink = response.data.signedUrl
        this.pdfDialogDownload = true
        //await AlertApi.downloadPdf(response)
        /* const nameReportDownload = (this.orderStartDate()[0] + "_" + this.orderStartDate()[1] + " " + (item.name || await this.getClientName(item)))
        response.data && response.data.success == true ? await AlertApi.downloadPdf(nameReportDownload) : showErrorSnackBar("Erro ao gerar pdf!") */
      }
    },
    async getClientName(item) {
      let data = []
      if (item.entity === "client") data = await firebase.getUserbyId(item.id)
      else data = await firebase.getUnitbyId(item.id)
      return data.name
    },
    orderStartDate() {
      if (this.startDatePicker[0] > this.startDatePicker[1]) {
        this.startDatePicker = [
          this.startDatePicker[1],
          this.startDatePicker[0]
        ]
      }
      this.startDatePicker = [
        this.startDatePicker[0],
        this.startDatePicker[1]
      ]
      return this.startDatePicker
    },
  },
  computed: {
    ...mapGetters([
      "getCurrentUser"
    ])
  },
  async created() {
    this.alertsConfigData = await AlertsConfigService.getAlertsConfig()
    await this.getUsersMap()
  }
}